const SITE_URL: string = 'https://acbuyspreadsheets.xyz';
const SITE_NAME: string = 'ACBuySpreadsheet';
const SITE_DESCRIPTION: string =
  'ACBuySpreadsheet is the most advanced spreadsheet tracking and optimization framework. Discover structured guides, automation tools, data comparison dashboards, and performance workflows for spreadsheet efficiency.';

export function getWebSiteJsonLd(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageJsonLd(
  pageUrl: string,
  pageTitle: string,
  pageDescription: string,
): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageTitle,
    url: `${SITE_URL}${pageUrl}`,
    description: pageDescription,
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: SITE_URL,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: pageTitle,
        },
      ],
    },
  };
}

export interface BlogPostingData {
  slug: string;
  title: string;
  intro: string;
  date: string;
  imageUrl: string;
}

export function getBlogPostingJsonLd(article: BlogPostingData): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: article.title,
    description: article.intro,
    image: article.imageUrl,
    datePublished: extractDate(article.date),
    dateModified: extractDate(article.date),
    author: {
      '@type': 'Organization',
      name: 'ACBuySpreadsheet Team',
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/article/${article.slug}`,
    },
  };
}

function extractDate(dateStr: string): string {
  const match = dateStr.match(/(\d{4})/);
  if (match) {
    return `${match[1]}-06-25`;
  }
  return '2026-06-25';
}